/** Chave do localStorage: alinhada ao header X-Tenant-Org-Id após /organizations/resolve */
export const TENANT_ORG_ID_STORAGE_KEY = 'x-tenant-org-id';
